<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'

const props = withDefaults(
  defineProps<{
    enabled?: boolean
  }>(),
  { enabled: true },
)

let applied = false

onMounted(() => {
  if (!props.enabled) return
  applied = true
  try {
    document.body.classList.add('landing-bg')
  } catch {}
})

onBeforeUnmount(() => {
  if (!applied) return
  try {
    document.body.classList.remove('landing-bg')
  } catch {}
})
</script>

<template>
  <div>
    <div v-if="props.enabled" class="grid-bg" aria-hidden="true"></div>
    <div v-if="props.enabled" class="glow" aria-hidden="true"></div>
    <slot />
  </div>
</template>
